import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  suggestions: [],
  error: false,
  isEmpty: false,
};

export const caseExamplesSrchSuggSlice = createSlice({
  name: "caseExamplesSrchSugg",
  initialState,
  reducers: {
    caseExamplesSrchSuggStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    caseExamplesSrchSuggSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      suggestions: action.payload,
    }),
    caseExamplesSrchSuggFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    updateIsEmptySugg: (state, action) => ({
      ...state,
      isEmpty: action.payload
    }),
    resetCaseExamplesSrchSugg: () => ({
      ...initialState
    }),
},
});

export const { 
  caseExamplesSrchSuggStart,
  caseExamplesSrchSuggSuccess,
  caseExamplesSrchSuggFailure,
  updateIsEmptySugg,
  resetCaseExamplesSrchSugg,
} = caseExamplesSrchSuggSlice.actions;

export const getCaseExamplesrchSugg = (token) => (dispatch) => {
  dispatch(caseExamplesSrchSuggStart());
  apiService.get(`${Constants.API.CASE_EXAMPLES_SUGGESTION}`, {
    params: { token },
  })
    .then((response) => {
      let data = verifyApiResponse(response);
      if (data?.systemMessage?.success) {
        dispatch(caseExamplesSrchSuggSuccess(data?.data));
        dispatch(updateIsEmptySugg(!data?.data?.length));
      } else {
        dispatch(caseExamplesSrchSuggFailure());
      }
    }).catch((error) => {
      dispatch(caseExamplesSrchSuggFailure());
    })
};

export default caseExamplesSrchSuggSlice.reducer;
